// export default {
//   init() {
//     // JavaScript to be fired on the home page
//   },
//   finalize() {
//     // JavaScript to be fired on the home page, after the init JS
//
//     let bulletNav = document.querySelector('.bullet-nav');
//     let bulletNavItem = bulletNav.querySelectorAll('li');
//
//     bulletNavItem.forEach(function(item){
//
//       item.addEventListener('click', function(){
//
//         var target = item.getAttribute('data-target');
//         var section = document.querySelector(target);
//         var sectionPosition = section.offsetTop;
//
//         window.scroll({
//           top: sectionPosition - 100,
//         });
//
//       });
//
//     });
//
//     document.addEventListener('scroll', function(){
//       checkCurrentPos();
//     });
//
//     let checkCurrentPos = function(){
//
//       let documentScroll = document.documentElement.scrollTop;
//
//       bulletNavItem.forEach(function(item, key){
//
//         var target = item.getAttribute('data-target');
//         var section = document.querySelector(target);
//         var sectionPosition = section.offsetTop;
//
//         var diff = documentScroll - sectionPosition + 250;
//
//         item.classList.remove('active');
//
//         if(diff > 0){
//           item.classList.add('active');
//
//           if(bulletNavItem[key-1] != undefined){
//             bulletNavItem[key-1].classList.remove('active');
//           }
//         }
//
//       });
//
//     };
//
//     checkCurrentPos();
//
//     let scrollDownBtn = document.querySelector('.btn-scroll-down');
//
//     if(scrollDownBtn){
//
//       scrollDownBtn.addEventListener('click', function(event){
//         event.preventDefault();
//         let target = document.querySelector(this.getAttribute('data-target')).offsetTop;
//         window.scroll({ top: target - 100 });
//       });
//
//     }
//
//   },
// };



// WEBPACK FOOTER //
// ./scripts/routes/home.js